/* Team suits landing page: variant, UTM capture, sticky CTA, thank-you + lead events */
(() => {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const STORAGE_KEY = 'tlp-utm';
  const LEAD_FIRED_KEY = 'tlp-lead-fired';
  const params = new URLSearchParams(window.location.search);

  const storage = {
    get(key) {
      try { return JSON.parse(sessionStorage.getItem(key)); } catch (error) { return null; }
    },
    set(key, value) {
      try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (error) { /* storage blocked: attribution falls back to the current URL only */ }
    },
  };

  /* Water polo variant: ?v=polo or utm_content/utm_term containing "polo" */
  const isPolo = params.get('v') === 'polo' || /polo/i.test(`${params.get('utm_content') || ''} ${params.get('utm_term') || ''}`);
  if (isPolo) document.documentElement.dataset.tlpVariant = 'polo';

  /* UTM capture: first-touch within the session, then fill matching hidden form fields */
  const fromUrl = Object.fromEntries(UTM_KEYS.filter((key) => params.get(key)).map((key) => [key, params.get(key)]));
  const utm = { ...(storage.get(STORAGE_KEY) || {}), ...fromUrl, landing_page: window.location.pathname };
  storage.set(STORAGE_KEY, utm);

  const fillHiddenFields = (root) => {
    Object.entries(utm).forEach(([key, value]) => {
      root.querySelectorAll(`input[name*="${key}"], input[data-label*="${key}" i]`).forEach((input) => {
        if (!input.value) input.value = value;
      });
    });
  };

  const embed = document.querySelector('[data-tlp-form-embed]');
  if (embed) {
    fillHiddenFields(embed);
    /* Globo renders the form after load; fill fields as soon as they appear */
    const observer = new MutationObserver(() => fillHiddenFields(embed));
    observer.observe(embed, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }

  /* Carry the session's UTMs onto outbound CTAs (e.g. the Design Tool) */
  document.querySelectorAll('a[data-tlp-pass-utm]').forEach((link) => {
    const href = link.getAttribute('href') || '';
    if (!href || href.startsWith('#')) return;
    try {
      const url = new URL(href, window.location.href);
      Object.entries(utm).forEach(([key, value]) => {
        if (key.startsWith('utm_') && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });
      link.href = url.toString();
    } catch (error) { /* malformed merchant URL: leave the link as authored */ }
  });

  /* Thank-you state: the form app redirects back with ?submitted=1 */
  const formSection = document.querySelector('[data-tlp-form]');
  const thanks = document.querySelector('[data-tlp-form-thanks]');
  if (params.get('submitted') === '1' && formSection && thanks) {
    formSection.classList.add('is-submitted');
    thanks.hidden = false;
    formSection.scrollIntoView({ block: 'start', behavior: 'instant' });
    thanks.focus({ preventScroll: true });
    fireLeadOnce();
  }

  function fireLeadOnce() {
    if (storage.get(LEAD_FIRED_KEY)) return;
    storage.set(LEAD_FIRED_KEY, true);
    const detail = { form: 'team-suits-lp', ...utm };
    if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', detail);
    if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'team-suits-lp' });
    if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('team_lp_lead', detail);
  }

  /* CTA clicks, for scroll-depth vs. CTA position analysis */
  document.querySelectorAll('[data-tlp-cta]').forEach((link) => {
    link.addEventListener('click', () => {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('team_lp_cta_click', { position: link.dataset.tlpCta });
      }
    });
  });

  /* Sticky mobile CTA: show after the hero leaves, hide while the form is on screen */
  const sticky = document.querySelector('[data-tlp-sticky]');
  const hero = document.querySelector('[data-tlp-hero]');
  if (sticky && hero && formSection && 'IntersectionObserver' in window) {
    const state = { heroVisible: true, formVisible: false };
    const stickyLink = sticky.querySelector('a');
    const render = () => {
      const show = !state.heroVisible && !state.formVisible && !formSection.classList.contains('is-submitted');
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      if (stickyLink) stickyLink.tabIndex = show ? 0 : -1;
    };
    const watch = (element, key) => new IntersectionObserver(([entry]) => {
      state[key] = entry.isIntersecting;
      render();
    }).observe(element);
    watch(hero, 'heroVisible');
    watch(formSection, 'formVisible');
  }
})();
